export enum IntegrationEnum {
  AIPEX = 'aipex',
  AIRBNB = 'airbnb',
  AIRINFORMED_COM = 'airinformed_com',
  AKIA = 'akia',
  ANYSTAY = 'anystay',
  APARTA = 'aparta',
  AUTHENTICATE = 'authenticate',
  AUTOHOST = 'autohost',
  AUTORANK = 'autorank',
  B0ARDING = 'b0arding',
  BEENEST = 'beenest',
  BESTY_AI = 'bestyAi',
  BEYONDPRICING = 'beyondpricing',
  BLUEGROUND = 'blueground',
  BNBFINDER = 'bnbfinder',
  BOOKDIRECT = 'bookdirect',
  BOOKING_COM = 'booking_com',
  BOOKINGTEAM = 'bookingteam',
  BOOSTLY = 'boostly',
  BOUNCE = 'bounce',
  BREEZEWAY = 'breezeway',
  BRITEYIELD = 'briteyield',
  CARTOBLUE = 'cartoblue',
  CHARGEAUTOMATION = 'chargeautomation',
  CHECKIN_SCAN = 'checkin_scan',
  CHEKIN = 'chekin',
  CLEANSTER_DOT_COM = 'cleansterDotCom',
  CLEARING = 'clearing',
  CLEVERFI = 'cleverfi',
  CLOVERLY = 'cloverly',
  CLYN = 'clyn',
  COHOST = 'cohost',
  CONCIERGEBOT = 'conciergebot',
  CONDUIT = 'conduit',
  CRAFTED_STAYS = 'craftedStays',
  CREWDOGS = 'crewdogs',
  CSA = 'csa',
  CTRLBNB = 'ctrlbnb',
  DHARMA = 'dharma',
  DOINN = 'doinn',
  DPGO = 'dpgo',
  DTRAVEL = 'dtravel',
  ECLEANIT = 'ecleanit',
  EGETINNZ = 'egetinnz',
  ENSO = 'enso',
  EVERBOOKED = 'everbooked',
  EXTENTEAM = 'extenteam',
  EZ_INSPECTIONS = 'ez_inspections',
  FEWOFERIEN = 'fewoferien',
  FIDO = 'fido',
  FINDRENTALS = 'findrentals',
  FLATAWAY = 'flataway',
  FOXHOLE = 'foxhole',
  GETAWAYGOGO = 'getawaygogo',
  GETHOSTAI = 'gethostai',
  GOLIGHTLY = 'golightly',
  GOOGLE = 'google',
  GUESTGENIE = 'guestgenie',
  GUEST_GURU = 'guest_guru',
  GUEST_LABS = 'guestLabs',
  HELLO_HERE = 'hello_here',
  HELLOGUESTSCREEN = 'helloguestscreen',
  HELLOSIGN = 'hellosign',
  HOLIDALE = 'holidale',
  HOLIDAYHOMES = 'holidayhomes',
  HOLIDU_COM = 'holidu_com',
  HOMADS = 'homads',
  HOMEAWAY = 'homeaway',
  HOMETOGO = 'hometogo',
  HOSPY = 'hospy',
  HOSTBUDDY_AI = 'hostbuddyAi',
  HOSTFI = 'hostfi',
  HOSTFULLY = 'hostfully',
  HOSTFULLYCAPITAL = 'hostfullycapital',
  HOSTFULLYDEVICES = 'hostfullydevices',
  HOSTKIT = 'hostkit',
  HOTELMINDER_COM = 'hotelminder_com',
  HOUFY = 'houfy',
  HUDSON_CREATIVE_STUDIO = 'hudson_creative_studio',
  HVMI = 'hvmi',
  ICOASTALNET = 'icoastalnet',
  IGLOOHOME_CO = 'igloohome_co',
  INGENICO = 'ingenico',
  INGENICO_EPAYMENTS = 'ingenico_epayments',
  INNTELLIGENCE = 'inntelligence',
  INSURAGUEST = 'insuraguest',
  IXOPAY = 'ixopay',
  IXOPAY_2 = 'ixopay_2',
  KEY_DATA = 'key_data',
  KNOKX = 'knokx',
  KOOPTICK = 'kooptick',
  LAKE = 'lake',
  LASOH = 'lasoh',
  LINKBASE = 'linkbase',
  LOCALBIRD = 'localbird',
  LODGABLE = 'lodgable',
  LODGELOVERS = 'lodgeLovers',
  LUGGAGEHERO = 'luggagehero',
  LYNNBROOK_GROUP = 'lynnbrook_group',
  MAILCHIMP = 'mailchimp',
  MASTERCARD = 'mastercard',
  MASTERCARD_PAYMENT_GATEWAY_SERVICE = 'mastercard_payment_gateway_service',
  MATTERPORT = 'matterport',
  MINISTAYS = 'ministays',
  MINUT = 'minut',
  MOVINGLAKE = 'movinglake',
  MYBOOKINGPAL = 'mybookingpal',
  MYGUESTBOOK = 'myguestbook',
  MYRATEMANAGER = 'myratemanager',
  NANNYBAG = 'nannybag',
  NEXTPAX = 'nextpax',
  NIGHTPRICER = 'nightpricer',
  NOISEAWARE = 'noiseaware',
  NOSHABLE = 'noshable',
  OK2CHARGE = 'ok2charge',
  OPERTO = 'operto',
  ORBIRENTAL = 'orbirental',
  OTAPLUS = 'otaplus',
  OUTSWITCH = 'outswitch',
  OWNERDIRECT = 'ownerdirect',
  PAYFULLY = 'payfully',
  PAYPAL = 'paypal',
  PERFECT_PRICE = 'perfect_price',
  PETSCREENING = 'petscreening',
  POINTCENTRAL = 'pointcentral',
  PRICELABS = 'pricelabs',
  PRIMEHOST = 'primeHost',
  PROPERLY = 'properly',
  QUIBBLE = 'quibble',
  QUICKBOOKS = 'quickbooks',
  RABBU = 'rabbu',
  REDAWNING = 'redawning',
  RELAXDAMAGEWAIVER = 'relaxdamagewaiver',
  REMOTELOCK = 'remotelock',
  RENTALS_UNITED = 'rentals_united',
  RENTALTONIC = 'rentaltonic',
  RENTAMIRA = 'rentamira',
  RENTED = 'rented',
  RESORTCLEANING = 'resortCleaning',
  REVA = 'reva',
  REVYOOS = 'revyoos',
  RIGHT2RENT = 'right2rent',
  SAFEGUEST = 'safeguest',
  SAFELY = 'safely',
  SANMIGUELDEALLENDEVACATION_COM = 'sanmigueldeallendevacation_com',
  SKILLEDHOSTS = 'skilledhosts',
  SMARTPINEAPPLE = 'smartPineapple',
  SMARTPRICING = 'smartpricing',
  SOJO = 'sojo',
  SPACEAGENT = 'spaceagent',
  SPREEDLY_TEST = 'spreedly_test',
  STARDEKK = 'stardekk',
  STAY = 'stay',
  STAYFI = 'stayfi',
  STAYNEARN = 'staynearn',
  STAYTRACK = 'stayTrack',
  STRIPE = 'stripe',
  STRLY = 'strly',
  SUITEOP = 'suiteop',
  SUMMEROS = 'summeros',
  SWIKLY = 'swikly',
  TASKASSURE = 'taskassure',
  TECHTAPE = 'techtape',
  TEST = 'test',
  TEXTREQUEST = 'textrequest',
  THE_MONAKER_GROUP = 'the_monaker_group',
  THEHOSTCO = 'thehostco',
  TINT = 'tint',
  TINYPNG = 'tinypng',
  TOPKEY = 'topkey',
  TRAMONA = 'tramona',
  TRAVELSTAYTION = 'travelstaytion',
  TRIPADVISOR = 'tripadvisor',
  TRUPLACE = 'truplace',
  TRUVI = 'truvi',
  TURBOSUITE = 'turbosuite',
  TURNOVERBNB = 'turnoverbnb',
  VACACITY = 'vacacity',
  VACATIONRENTPAYMENT = 'vacationrentpayment',
  VACAYMYWAY = 'vacaymyway',
  VIEWRETREATS = 'viewretreats',
  VIKEY = 'vikey',
  VIRTUALKEY = 'virtualkey',
  VRASIO = 'vrasio',
  VRPLATFORM = 'vrplatform',
  VRSCHEDULER = 'vrscheduler',
  VYDE = 'vyde',
  WHEELHOUSE = 'wheelhouse',
  WHIMSTAY = 'whimstay',
  WYND = 'wynd',
  YADA = 'yada',
  ZAPIER = 'zapier',
}

export enum IntegrationType {
  CHANNEL = 'CHANNEL',
  INTEGRATION = 'INTEGRATION',
}

export enum IntegrationCategory {
  DIRECT_CHANNEL = 'DIRECT_CHANNEL',
  CHANNEL_MANAGER = 'CHANNEL_MANAGER',
  HOSTFULLY_PRODUCTS = 'HOSTFULLY_PRODUCTS',
  PAYMENTS = 'PAYMENTS',
  DYNAMIC_PRICING = 'DYNAMIC_PRICING',
  HOME_AUTOMATION = 'HOME_AUTOMATION',
  CLEANING_AND_TURNOVER = 'CLEANING_AND_TURNOVER',
  ACCOUNTING = 'ACCOUNTING',
  INSURANCE_AND_SCREENING = 'INSURANCE_AND_SCREENING',
  DIGITAL_SIGNATURES = 'DIGITAL_SIGNATURES',
  CUSTOM_WEBSITES = 'CUSTOM_WEBSITES',
  BRAND_MANAGEMENT = 'BRAND_MANAGEMENT',
  LISTING_TOOLS = 'LISTING_TOOLS',
  ANALYTICS_TOOLS = 'ANALYTICS_TOOLS',
  GUEST_EXPERIENCE = 'GUEST_EXPERIENCE',
  REVIEWS = 'REVIEWS',
  IMAGE_COMPRESSION = 'IMAGE_COMPRESSION',
  WORKFLOW_AUTOMATIONS = 'WORKFLOW_AUTOMATIONS',
  COMMUNICATIONS = 'COMMUNICATIONS',
  INDUSTRY_ORGANIZATIONS = 'INDUSTRY_ORGANIZATIONS',
}

export enum DisplayStatus {
  VISIBLE = 'VISIBLE',
  HIDDEN = 'HIDDEN',
  COMING_SOON = 'COMING_SOON',
}

export enum ConnectionConfigType {
  INBOUND_OAUTH = 'INBOUND_OAUTH',
  OUTBOUND_OAUTH = 'OUTBOUND_OAUTH',
  LEGACY_V2_SWITCH = 'LEGACY_V2_SWITCH',
  SWITCH = 'SWITCH',
}

export enum IntegrationStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  PENDING = 'PENDING',
  NOT_SUPPORTED = 'NOT_SUPPORTED',
}

export type ConnectionConfig =
  | { type: ConnectionConfigType.INBOUND_OAUTH; connectLink: string }
  | { type: ConnectionConfigType.OUTBOUND_OAUTH; connectLink: null }
  | { type: ConnectionConfigType.LEGACY_V2_SWITCH; connectLink: null }
  | { type: ConnectionConfigType.SWITCH; connectLink: null };

export enum MuSupportType {
  HOTEL = 'HOTEL',
  UNIT_TYPE = 'UNIT_TYPE',
  NONE = 'NONE',
  BOTH = 'BOTH',
}

export enum PermissionScope {
  READ = 'READ',
  WRITE = 'WRITE',
  NONE = 'NONE',
}

export enum IntegrationBadge {
  NEW = 'NEW',
  FEATURED = 'FEATURED',
  ELITE = 'ELITE',
  PREFERRED = 'PREFERRED',
  INCLUDED_FOR_FREE = 'INCLUDED_FOR_FREE',
}

export enum CustomIntegrationSettingsType {
  HOSTFULLY_DEVICES = 'HostfullyDevicesIntegrationSettings',
  HOSTFULLY_CAPITAL = 'HostfullyCapitalIntegrationSettings',
  HOSTFULLY_GUIDEBOOKS = 'HostfullyGuidebooksIntegrationSettings',
  HELLOSIGN = 'hellosign',
  TINYPNG = 'tinypng',
  MAILCHIMP = 'mailchimp',
  PAYPAL = 'paypal',
  POINTCENTRAL = 'pointcentral',
  POINTCENTRAL_PROPERTY = 'pointcentralPropertySettings',
  STRIPE = 'stripe',
  VACATIONRENTPAYMENT = 'vacationrentpayment',
  ZAPIER = 'zapier',
  REMOTELOCK = 'remotelock',
  REMOTELOCK_PROPERTY = 'remotelockPropertySettings',
  READ_ONLY_ACCESS_SETTINGS = 'readOnlyAccessSettings',
}

export interface Integration {
  id: number;
  enumId: IntegrationEnum;
  type: IntegrationType;
  category: IntegrationCategory;
  name: string;
  displayName: string | null;
  logo: string;
  displayStatus: DisplayStatus;
  distributionGeography: string;
  connectionConfig: ConnectionConfig;
  muSupportType: MuSupportType;
  permissionScope: PermissionScope;
  rateMultiplierSupported: boolean;
  badges: IntegrationBadge[];
  allowedForAgencyOnly: boolean;
}

export interface IntegrationStats {
  connectedProperties: number;
  connectedAccounts: number;
}

export enum RemoteLockAccessibleType {
  ACS_DOOR = 'acs_door',
  ACS_ELEVATOR_FLOOR = 'acs_elevator_floor',
  LOCK = 'lock',
  ZWAVE_LOCK = 'zwave_lock',
  SCHLAGE_HOME_LOCK = 'schlage_home_lock',
  DOOR_GROUP = 'door_group',
  RESORT_LOCK = 'resort_lock',
  LOCATION = 'location',
  CONNECTOR_LOCK = 'connector_lock',
  IGLOO_LOCK = 'igloo_lock',
  UNSUPPORTED = 'unsupported',
}

export interface RemoteLockSettings {
  lockId?: string;
  lockName?: string;
  accessibleType?: RemoteLockAccessibleType;
  guestId?: string;
  pincodeDefaultLength?: number;
}

export type CustomIntegrationSettings =
  | {
      type:
        | CustomIntegrationSettingsType.HELLOSIGN
        | CustomIntegrationSettingsType.TINYPNG;
      hasApiKey?: boolean;
    }
  | {
      type: CustomIntegrationSettingsType.MAILCHIMP;
      hasApiKey?: boolean;
      listId?: string;
    }
  | {
      type: CustomIntegrationSettingsType.PAYPAL;
      email?: string;
      trackingIdCounter?: string;
      apikey?: string;
    }
  | {
      type: CustomIntegrationSettingsType.POINTCENTRAL_PROPERTY;
      assignedLock?: string;
    }
  | {
      type: CustomIntegrationSettingsType.POINTCENTRAL;
      apiKey?: string;
      hasApiKey: boolean;
      login?: string;
      availableLocks?: Record<string, number>;
    }
  | {
      type: CustomIntegrationSettingsType.STRIPE;
      stripeSettingsJson?: string;
      stripeCode?: string;
      accountEmail?: string;
    }
  | {
      type: CustomIntegrationSettingsType.VACATIONRENTPAYMENT;
      username?: string;
      password?: string;
      propertyCode?: string;
    }
  | {
      type: CustomIntegrationSettingsType.ZAPIER;
      zapierSecret?: string;
    }
  | {
      type:
        | CustomIntegrationSettingsType.HOSTFULLY_DEVICES
        | CustomIntegrationSettingsType.HOSTFULLY_CAPITAL
        | CustomIntegrationSettingsType.HOSTFULLY_GUIDEBOOKS;
      accessUrl?: string;
    }
  | {
      type: CustomIntegrationSettingsType.READ_ONLY_ACCESS_SETTINGS;
      enableReadOnlyAccessForAllProperties?: boolean;
    }
  | {
      type: CustomIntegrationSettingsType.REMOTELOCK;
      remoteLockSettings?: RemoteLockSettings[];
      pincodeLength?: number;
    }
  | {
      type: CustomIntegrationSettingsType.REMOTELOCK_PROPERTY;
      assignedLock?: string;
      accessibleType?: RemoteLockAccessibleType;
    };

export interface AgencySettings {
  enumId: IntegrationEnum;
  agencyUid: string;
  status: IntegrationStatus;
  rateMultiplier?: number;
  settingsCreatedAt?: string;
  settingsUpdatedAt?: string;
  customIntegrationSettings: CustomIntegrationSettings | null;
  agencyConfirmed: boolean;
}

export interface InternalIntegrationSetting {
  id: number;
  enumId: IntegrationEnum;
  integration: Integration;
  integrationStats: IntegrationStats;
  agencySettings: AgencySettings;
}

export interface PropertySetting {
  propertyUid: string;
  status: IntegrationStatus;
  settingsCreatedAt: string;
  settingsUpdatedAt: string;
  publicLink: string | null;
  activeAgencyIntegrationSettings: AgencySettings | null;
  customIntegrationSettings: CustomIntegrationSettings | null;
}

export interface GetInternalIntegrationSettingsResponseTO {
  integrationSettings: InternalIntegrationSetting[];
}

export interface AgencySettingsUpdatePayload {
  rateMultiplier: number;
}

export interface PropertySettingsResponseTO {
  enumId: IntegrationEnum;
  integration: Integration;
  propertySettings: PropertySetting[];
}

export interface GetIntegrationAgencySettingsResponseTO {
  enumId: IntegrationEnum;
  integration: Integration;
  agencySettings: AgencySettings;
}

export interface PropertiesActivityResponseTO {
  allAvailablePropertiesActive: boolean;
}

export interface PostOutboundOAuthRedirectURLResponseTO {
  oauthDetails: {
    redirectUrl: string;
  };
}
